/*
    SUMMARY
    0 - AUTO YEAR
    1 - BACK TO TOP
*/


export default function Footer() {

    /*-----------------/ 0 - Const / Variables /--------------------*/


    /*-----------------/ 1 - Function /--------------------*/


    /*-----------------/ 2 - AUTO YEAR /--------------------*/
    const currentYear = new Date().getFullYear()
    const yearElement = document.querySelector('.auto--year')
    yearElement.innerHTML = currentYear

    document.addEventListener('DOMContentLoaded', function() {
        const mobileMenuTrigger = document.querySelector('.nav__mobile');
        const mobileMenu = document.querySelector('.nav__menu-mobile');
        const closeButton = document.querySelector('.nav__menu-close');

        mobileMenuTrigger?.addEventListener('click', () => {
            mobileMenu.classList.add('active');
        });

        closeButton?.addEventListener('click', () => {
            mobileMenu.classList.remove('active');
        });
    });
}
